/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(function() {
  
  console.log("testing");
    $('input.acceptTerms').click(function() {
        var unchecked = $('input.acceptTerms:not(:checked)').length;
        if (unchecked == 0) {
            $('#customm').removeAttr('disabled');
        }
        else {
            $('#customm').attr('disabled', 'disabled');
        }
    });
});
